<template>
  <header class="header" :style="{ backgroundColor: headerColor }">
    <div class="container">
      <h1 class="header__logo" :style="{ backgroundImage: `url(${logo})` }">{{ clientName }}</h1>
    </div>
  </header>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "BrandChannelHeader",
  computed: mapState({
    logo: state => state.brandChannel.tape.brand_channel.logo,
    clientName: state => state.brandChannel.tape.brand_channel.client_name,
    headerColor: state => state.brandChannel.tape.brand_channel.header_color
  })
};
</script>

<style>
.header {
  padding: 10px 0;
  overflow: hidden;
}

.header__logo {
  float: left;
  height: 32px;
  width: 120px;
  text-indent: -9999px;
  background-position: center left;
  background-repeat: no-repeat;
  background-size: contain;
}
</style>
